<div class="list-group list-group-flush entity-facet">
    <div class="list-group-item align-items-center border-0 py-1 px-3 d-flex" *ngFor="let value of entityValues">
        <span class="text-muted px-1 cursor-pointer" (click)="toggleEntity(value)">
            <i class="far" [ngClass]="{'fa-check-square': !entityHidden(value), 'fa-square': entityHidden(value)}"></i>
        </span>
        <span class="me-auto mx-1">{{ value.displayValue | sqValue:column }}</span>
        <span class="text-muted small mx-1">{{ entityCount(value) }}</span>
        <span *ngIf="previewDocument" class="text-muted px-1 cursor-pointer" (click)="prevEntity(value)" title="{{ 'msg#preview.previousHighlightButtonAltText' | sqMessage }}"><i class="fas fa-chevron-left"></i></span>
        <span *ngIf="previewDocument" class="text-muted px-1 cursor-pointer" (click)="nextEntity(value)" title="{{ 'msg#preview.nextHighlightButtonAltText' | sqMessage }}"><i class="fas fa-chevron-right"></i></span>
    </div>
    <div class="list-group-item border-0 py-1 text-center" *ngIf="data.length > count">
        <a class="text-muted small" href="#" (click)="showAll()" title="{{ 'msg#preview.showAll' | sqMessage }}">{{ 'msg#preview.showAll' | sqMessage }}</a>
    </div>
</div>
